import type { SupportedCurrencies } from '../components/Utility/VoPayApi/VoPayApi.types';

const currencyOptions: { [key in SupportedCurrencies]?: string } = {
  CAD: 'CAD',
  USD: 'USD',
};

export default currencyOptions;
